export default __webpack_public_path__ + "static/media/mkicon.ffb82d14.png";